export { default as calcDamage } from "./calcDamage";
